import { render, staticRenderFns } from "./PreRegister.vue?vue&type=template&id=a6aa25ac&scoped=true"
import script from "./PreRegister.vue?vue&type=script&lang=js"
export * from "./PreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aa25ac",
  null
  
)

export default component.exports